import { render, staticRenderFns } from "./WriteExpress.vue?vue&type=template&id=15921f40&scoped=true"
import script from "./WriteExpress.vue?vue&type=script&lang=js"
export * from "./WriteExpress.vue?vue&type=script&lang=js"
import style0 from "./WriteExpress.vue?vue&type=style&index=0&id=15921f40&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15921f40",
  null
  
)

export default component.exports